module.exports = __webpack_public_path__ + "static/media/icons_Bilan Libre Membres Inférieurs.d148d253.svg";